import script from "./contract-detail.vue?vue&type=script&lang=tsx&setup=true"
export * from "./contract-detail.vue?vue&type=script&lang=tsx&setup=true"

import "./contract-detail.vue?vue&type=style&index=0&id=29f680ed&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29f680ed"]])

export default __exports__